import React from 'react';
import '../Assets/css/Monitoreo.css'; // Asegúrate de tener un archivo CSS para estilos

export const Monitoreo = () => {
    return (
        <div className="monitoring-section">
            <div className="container-monitoring">

                <div className="monitoring-content">
                    <h1>Sala de Monitoreo 24/7</h1>
                    <p>
                        Contamos con una sala de monitoreo para los vehículos que opera 24/7. Utilizamos tecnología
                        avanzada,
                        como GPS y sensores, para rastrear en tiempo real la ubicación y el rendimiento de cada
                        vehículo, lo
                        que garantiza eficiencia operativa y seguridad.
                    </p>
                    <p>
                        El equipo de monitoreo también se encuentra capacitado para responder rápidamente a emergencias
                        y
                        optimiza las rutas para mejorar la puntualidad y reducir el consumo de combustible. Además,
                        brinda
                        apoyo a los conductores en la carretera informando estado y situaciones de las rutas. En
                        general,
                        esta iniciativa muestra el compromiso de Pluss Minería con la excelencia en el transporte y la
                        seguridad de sus pasajeros y empleados.
                    </p>
                </div>
            </div>
        </div>
    );
}


